import PieChart from "components/charts/PieChart";
import { pieChartData, pieChartOptions } from "variables/charts";
import Card from "components/card";

const PieChartCard = () => {
  return (
    <Card extra="rounded-[20px] p-3">
      <div className="flex flex-row justify-between px-3 pt-2">
        <div>
          <h4 className="card-title">
            Staff Movement
          </h4>
        </div>

        <div className="mb-6 flex items-center justify-center">
          <select className="mb-3 mr-2 flex items-center justify-center text-sm font-bold text-gray-600 hover:cursor-pointer dark:!bg-intsamis-800 dark:text-white">
            <option value="monthly">Monthly</option>
            <option value="quarterly">Quarterly</option>
            <option value="yearly">Yearly</option>            
          </select>
        </div>
      </div>

      <div className="mb-auto flex h-[180px] w-full items-center justify-center">
        <PieChart options={pieChartOptions} series={pieChartData} />
      </div>
      <div className="flex flex-row !justify-between rounded-2xl px-6 py-3 shadow-2xl shadow-shadow-500 dark:!bg-intsamis-700 dark:shadow-none">
        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center justify-center">
            
            <div className="h-2 w-2 rounded-full bg-[#6AD2FF]" />
            <p className="ml-1 text-sm font-normal text-gray-600">New Hires</p>
          </div>
          <p className="mt-px text-xl font-bold text-theme-700  dark:text-white">
            10%
          </p>
        </div>  
        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center justify-center">
            
            <div className="h-2 w-2 rounded-full bg-[#1b3bbb]" />
            <p className="ml-1 text-sm font-normal text-gray-600">Retention</p>
          </div>
          <p className="mt-px text-xl font-bold text-theme-700  dark:text-white">
            87%
          </p>
        </div>     
        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center justify-center">
            <div className="h-2 w-2 rounded-full bg-[#991b1b]" />
            <p className="ml-1 text-sm font-normal text-gray-600">Attrition</p>
          </div>
          <p className="mt-px text-xl font-bold text-theme-700 dark:text-white">
            3%
          </p>
        </div>
      </div>
    </Card>
  );
};

export default PieChartCard;
